import React, { ReactNode } from "react"
import { RightBlockData, CalculatorMode } from "./types"
import { IconMoney } from "./icons/IconMoney"
import { IconPercent } from "./icons/IconPercent"

interface CalculatorTab {
  modeTab: CalculatorMode
  buttonText: string
  headDescr: ReactNode
  inputLabel: string
  rightBlock: RightBlockData
}

export const calculatorTabs: CalculatorTab[] = [
  {
    modeTab: "installment",
    buttonText: "Рассрочка",
    headDescr: (
      <>
        Рассрочка без переплат: <br className="d-sm-none" />
        проценты заплатит магазин
      </>
    ),
    inputLabel: "Сумма покупки",
    rightBlock: {
      title: "Ежемесячный платеж",
      benefitText: "Переплата",
      benefitValue: "0 ₽",
      icon: <IconMoney />,
      iconDescr: (
        <>
          Вы платите только <br />
          стоимость товара
        </>
      ),
      arrowCalculator: true,
    },
  },
  {
    modeTab: "cashback",
    buttonText: "Кешбэк",
    headDescr: (
      <>
        Совершайте покупки у партнёров <br />и получайте до 10% кешбэка
      </>
    ),
    inputLabel: "Сумма покупки у партнера",
    rightBlock: {
      title: "Ваша прибыль",
      benefitText: "Размер кешбэка",
      benefitValue: "до 10%",
      icon: <IconPercent />,
      iconDescr: (
        <>
          Подписка «Халва.Десятка» <br />
          удваивает кешбэк по карте
        </>
      ),
    },
  },
]
